import chroma from 'chroma-js';

export function hexToRgba(hex: string, opacity: number) {
  if (hex) {
    const hexValue = hex.replace('#', '');
    const r = parseInt(hexValue.substring(0, 2), 16);
    const g = parseInt(hexValue.substring(2, 4), 16);
    const b = parseInt(hexValue.substring(4, 6), 16);

    return `rgba(${r},${g},${b},${opacity})`;
  }

  console.warn('The hex value was not valid:', hex);
  return 'rgba(0,0,0,1)';
}

export function darken(color: string, ratio: number): string {
  return chroma.mix(color, '#000000', ratio, 'rgb').hex();
}

export function lighten(color: string, ratio: number): string {
  return chroma.mix(color, '#ffffff', ratio, 'rgb').hex();
}
